import * as React from 'react';
import {useFindLibraryDurationQuery} from 'features/channelCatalog/channelCatalogApi';
import {IChannelCatalogItem, IChannelCatalogQuery} from 'models/channelCatalog';

export const useChannelCatalogLibraryDuration = (
  channelId?: string,
  movedToQueue: IChannelCatalogItem[] = [],
): {
  duration: number;
  fetch: (searchParams?: Partial<IChannelCatalogQuery>) => void;
  refetch: () => void;
  isFetching: boolean;
} => {
  const [newItemsTotalDuration, setNewItemsTotalDuration] = React.useState<number>(0);
  const [params, setParams] = React.useState<Partial<IChannelCatalogQuery>>({});

  const {data, isError, error, refetch, isLoading} = useFindLibraryDurationQuery(
    {channelId: channelId || '', ...params},
    {
      skip: !channelId,
    },
  );

  React.useEffect(() => {
    const totalMovedToQueueDuration = movedToQueue.reduce((acc, item) => acc - item.duration, 0);
    setNewItemsTotalDuration(totalMovedToQueueDuration);
  }, [movedToQueue]);

  const fetch = React.useCallback((searchParams?: Partial<IChannelCatalogQuery>) => {
    const {updatedAt, ...restParams} = searchParams || {};
    setParams({...updatedAt, ...restParams});
  }, []);

  return {
    duration:
      isError && (error as {status: number})?.status !== 404 ? 0 : (data?.duration || 0) + newItemsTotalDuration,
    fetch,
    isFetching: isLoading,
    refetch,
  };
};
